import { apiClient } from './apiClient';

export interface KanbanDto {
  id: string;
  day: string;
  title: string;
  time: string;
  location?: string;
  category: 'reuniao'|'analise'|'relatorio'|'criativo'|'admin'|'social'|'planejamento'|string;
}

export async function listKanban() {
  const data = await apiClient.get<{ items: KanbanDto[] }>(`/kanban`);
  return data.items;
}

export async function createKanban(task: KanbanDto) {
  return apiClient.post<KanbanDto>(`/kanban`, task);
}

export async function deleteKanban(id: string) {
  return apiClient.delete(`/kanban/${id}`);
}

export async function updateKanban(id: string, patch: Partial<KanbanDto>) {
  return apiClient.patch<KanbanDto>(`/kanban/${id}`, patch);
}
